import { render } from "./HeaderEditorBlock.vue?vue&type=template&id=3dd35c67&scoped=true"
import script from "./HeaderEditorBlock.vue?vue&type=script&lang=js"
export * from "./HeaderEditorBlock.vue?vue&type=script&lang=js"

import "./HeaderEditorBlock.vue?vue&type=style&index=0&id=3dd35c67&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd35c67"]])

export default __exports__